import { createContext } from "react";

export interface ReauthenticationFlowOptions {
  onSuccess: () => Promise<void> | void;
  onError?: (error?: any) => void;
  onCancel?: () => void;
}

export type ReauthenticationContextType = {
  onStart: (opts: ReauthenticationFlowOptions) => void;
  onCancel: () => void;
};

const ReauthenticationContext = createContext<ReauthenticationContextType | undefined>(undefined);
ReauthenticationContext.displayName = "ReauthenticationContext";

export default ReauthenticationContext;
